import { render } from "./info_personal.vue?vue&type=template&id=65a64553"
import script from "./info_personal.vue?vue&type=script&lang=js"
export * from "./info_personal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__